import { Endpoints } from "src/base/Endpoints";
import { Agent } from "https";
import axios from "axios";
import { TOKEN } from "../../features/auth/data/datasources/authRemoteDatasource";

export class TempUploadDataSource {

    async uploadToTemp(formData: FormData): Promise<any> {
        try {
            const agent = new Agent({
                rejectUnauthorized: false,
            });

            const response = await axios({
                method: "POST",
                url: process.env.REACT_APP_API_URL + Endpoints.uploadFileManagement,
                maxContentLength: Infinity,
                maxBodyLength: Infinity,
                httpsAgent: agent,
                data: formData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem(TOKEN) ?? "",
                },
            });

            return response.data;
        } catch (e) {
            this._handleError(e);
        }
    }

    _handleError(error: any) {
        const data: any = {
            error: error,
            status: false,
        };
        if (error.response && error.response.data) {
            data.data = error.response.data;
        }
        let errorText: any = "";
        if (data.data) {
            if (data.data.details) {
                const errors = Object.values(data.data.details[Object.keys(data.data.details)[0]]);
                if (Array.isArray(errors)) {
                    errorText = errors[0];
                }
            } else {
                errorText = data.data.message ?? "";
            }
        } else if (data.error && data.error.details) {
            if (data.error.details) {
                const errors = Object.values(data.error.details[Object.keys(data.error.details)[0]]);
                if (Array.isArray(errors)) {
                    errorText = errors[0];
                }
            } else {
                errorText = data.error.message ?? "";
            }
        }
        throw errorText;
    }
}